import { Button, ButtonArea, Dialog, Heading } from './base';
import { confluenceAuthService } from '../libs/services/ConfluenceAuthService';
import kmsIcon from '../assets/etc-icons/icon_book.svg';


export const KMS_GUIDE_KEY = 'ConfluenceConnector';

interface KmsConnectPopupProps {
  isOpen: boolean;
  onClose?: () => void;
}


export const KmsConnectPopup: React.FC<KmsConnectPopupProps> = ({ isOpen, onClose }) => {
  const close = () => {
    if (onClose) onClose();
  };

  const handleConnect = () => {
    try {
      const popup = confluenceAuthService.registerConfluencePopup();
      if (!popup) alert('팝업 차단을 해제해주세요.');
    } catch (e) {
      console.error('KMS 연결 팝업 오류:', e);
    }
    if (onClose) onClose();
  };

  return (
    <Dialog
      isOpen={isOpen}
      size="medium"
      className="dialog-tutorial dialog-feedback"
      closeOnOutSide={false}
      onClose={close}
      buttons={
        <ButtonArea align="center">
          <Button variant="outline" onClick={close}>
            다음에
          </Button>
          <Button variant="primary" onClick={handleConnect}>
            연결하기
          </Button>
        </ButtonArea>
      }
    >
      <div className="feedback-header dsx-Dialog-header">
        <Heading as="h2" size="title3" weight="semibold" className="title">
          지식자산시스템(KMS) 연결
        </Heading>
      </div>

      <div className="tutorial-contents">
        <div className="contents">
          <div className="kms-icon-wrap">
            <img src={kmsIcon} alt="KMS" />
          </div>
          <div className="contents-description">
            <Heading size="title2">
              사내 지식을 활용을 위해 
              <br />
              <span className="description-emp">Works AI</span>에서 <span className="description-emp">KMS</span>를 연결해보세요.
            </Heading>
          </div>
          <p className="kms-connect-desc">
            KMS의 업무 지식을 검색·요약하고,
            <br />
            AI로 정리한 내용을 바로 공유할 수 있어요.
          </p>
        </div>
      </div>
    </Dialog>
  );
};
